import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const API_CMO_URL = process.env.REACT_APP_API_ENDPOINT_CMO

export const apiCmo = createApi({
  reducerPath: "apiCmo",
  baseQuery: fetchBaseQuery({
    baseUrl: API_CMO_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      return headers
    },
  }),
  endpoints: () => ({}),
})
